export const BarsProgressDuotone = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="bars-progress-duotone 1" clipPath="url(#clip0_149_905)">
      <path
        id="Vector"
        d="M-0.000244141 3.9377C-0.000244141 3.00606 0.755615 2.2502 1.68726 2.2502H11.2498V7.8752H1.68726C0.755615 7.8752 -0.000244141 7.11934 -0.000244141 6.1877V3.9377ZM-0.000244141 11.8127C-0.000244141 10.8811 0.755615 10.1252 1.68726 10.1252H6.74976V15.7502H1.68726C0.755615 15.7502 -0.000244141 14.9943 -0.000244141 14.0627V11.8127Z"
        fill="#2C58B6"
      />
      <path
        id="Vector_2"
        opacity="0.4"
        d="M11.2498 7.8752H16.3123C17.2439 7.8752 17.9998 7.11934 17.9998 6.1877V3.9377C17.9998 3.00606 17.2439 2.2502 16.3123 2.2502H11.2498V4.5002H15.7498V5.6252H11.2498V7.8752ZM6.74976 15.7502H16.3123C17.2439 15.7502 17.9998 14.9943 17.9998 14.0627V11.8127C17.9998 10.8811 17.2439 10.1252 16.3123 10.1252H6.74976V12.3752H15.7498V13.5002H6.74976V15.7502Z"
        fill="#4097F4"
      />
    </g>
    <defs>
      <clipPath id="clip0_149_905">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
